import React, { Fragment } from "react"
import { Link } from "react-router"

import { Section } from "ui"
import logoWhite from "assets/images/stacker-logo-white.png"

import { Logo } from "../ui/Layout"
import WithApps from "data/wrappers/WithApps"

import Sidebar from "../ui/Sidebar"
import SidebarSection from "./SidebarSection"
import SideBarItem, { SidebarLabel } from "./SideBarItem"

const StudioSidebar = props => {
    return (
        <Sidebar open={props.open}>
            {props.closeButton}
            <Link style={{ height: 65 }} to="/">
                <Logo src={logoWhite} alt="Stacker Logo" />
            </Link>
            <span>
                <SidebarSection icon="menuDesign" name="Apps" url="apps">
                    <SidebarLabel>Apps</SidebarLabel>

                    <WithApps>
                        {({ apps }) => {
                            return apps.map(app => (
                                <SideBarItem icon="app" label={app.name} url={"apps/" + app._sid} color="yellow" />
                            ))
                        }}
                    </WithApps>

                    {/* // return (
                            //     <Dropdow
                            //         onChange={selectApp}
                            //         placeholder="Select app"
                            //         clearable={false}
                            //         options={apppsToOptions(apps || [])}
                            //         value={selectedApp._sid}
                            //     />
                            // ) */}

                    <SidebarLabel>Design</SidebarLabel>
                    <SideBarItem icon="page" label="Pages" url="pages" exactUrl="/pages" color="red" />
                    <SideBarItem icon="plugin" label="Blocks" url="blocks" color="red" />
                </SidebarSection>
                <SidebarSection icon="menuData" name="Data" url="data">
                    <SidebarLabel>Data</SidebarLabel>
                    <SideBarItem icon="table" label="Tables" url="tables" color="blue" />
                </SidebarSection>
            </span>
        </Sidebar>
    )
}

export default StudioSidebar



// WEBPACK FOOTER //
// ./src/features/studio/components/StudioSidebar.js